<div class="card m-0 bg-transparent">
  <div class="card-body">
    <div class="row d-flex justify-content-between align-items-center ">
      <div class="col-10 d-flex align-items-center">
        <h4 class="card-title m-0 offcanvas-header-text d-flex align-items-center">
          Allow Public Groups
          <i
            class="mdi mdi-information-outline font-size-16 ms-1"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Enable you to Adverts."
          ></i>
        </h4>
      </div>
      <div class="col-2 d-flex justify-content-end">
        <ui-switch
          [color]="offcanvasColors.activeColor"
          [switchColor]="offcanvasColors.switchColor"
          [defaultBgColor]="offcanvasColors.bgColor"
          [defaultBoColor]="offcanvasColors.borderColor"
          [checkedTextColor]="offcanvasColors.activeTextColor"
          [uncheckedTextColor]="offcanvasColors.offTextColor"
          uncheckedLabel="Off"
          [checked]="enableAds"
          checkedLabel="On"
          size="small"
          class="me-1"
          (change)="toggleAds($event)"
        ></ui-switch>
      </div>
    </div>

  </div>
</div>
